import { newE2EPage } from "@stencil/core/testing";

const data = [
    { name: "TruMark", type: "Laser Machine", id: "ZU3" },
    { name: "TruLaser", type: "Precision Machine", id: "ZE7" },
    { name: "TruMark+", type: "Laser Machine", id: "CT7" },
    { name: "TruLaser-v4", type: "Precision Machine", id: "WS3" }
];

describe("filter table", () => {
    let page;
    let table;
    beforeEach(async () => {
        page = await newE2EPage();
        await page.setContent(
            `<uic-table>
                <uic-table-column
                field="id"
                label="ID"
                filterable
               ></uic-table-column>
               <uic-table-column
                field="name"
                label="Name"
               ></uic-table-column>
               <uic-table-column
                field="type"
                label="Type"
                filterable
                ></uic-table-column>
             </uic-table>`
        );
        table = await page.find("uic-table");
        table.setProperty("data", data);
        await page.waitForChanges();
    });
    it("should render the table component", async () => {
        const tableComponent = await page.find("uic-table");
        expect(tableComponent).toHaveClass("hydrated");
    });

    it("should have only one row, when filter for id", async () => {
        const idColumn = await table.find('[data-testid="uic-table__th-id"]');

        await idColumn.click();
        await page.waitForChanges();

        const filterChckBoxes = await table.findAll("uic-table-head-filter >>> uic-checkbox");

        expect(filterChckBoxes.length).toBeGreaterThanOrEqual(2);

        await filterChckBoxes[3].click();

        const filterButton = await table.findAll("uic-table-head-filter >>> uic-button");

        //click confirm
        filterButton[1].click();
        await page.waitForChanges();

        const rows = await table.findAll(".uic-table__tr");
        expect(rows.length).toBe(1);
        const id = (await table.find('[data-testid="uic-table__td-id"]')).innerText;
        const name = (await table.find('[data-testid="uic-table__td-name"]')).innerText;
        const type = (await table.find('[data-testid="uic-table__td-type"]')).innerText;

        expect(id).toBe(data[3].id);
        expect(name).toBe(data[3].name);
        expect(type).toBe(data[3].type);
    });

    it("should have only one row, when first filter for type and than for id, and check reset filter", async () => {
        const typeColumn = await table.find('[data-testid="uic-table__th-type"]');

        await typeColumn.click();
        await page.waitForChanges();

        let filterChckBoxes = await typeColumn.findAll("uic-table-head-filter >>> uic-checkbox");

        await filterChckBoxes[1].click();
        let filterButton = await typeColumn.findAll("uic-table-head-filter >>> uic-button");

        //click confirm
        filterButton[1].click();
        await page.waitForChanges();

        let rows = await table.findAll(".uic-table__tr");
        expect(rows.length).toBe(2);

        //filter additionally by id
        const idColumn = await table.find('[data-testid="uic-table__th-id"]');

        await idColumn.click();
        await page.waitForChanges();

        filterChckBoxes = await idColumn.findAll("uic-table-head-filter >>> uic-checkbox");

        await filterChckBoxes[1].click();

        //click confirm
        filterButton = await table.findAll("uic-table-head-filter >>> uic-button");
        filterButton[1].click();
        await page.waitForChanges();

        rows = await table.findAll(".uic-table__tr");
        expect(rows.length).toBe(1);
        const id = (await table.find('[data-testid="uic-table__td-id"]')).innerText;
        const name = (await table.find('[data-testid="uic-table__td-name"]')).innerText;
        const typeValue = (await table.find('[data-testid="uic-table__td-type"]')).innerText;

        expect(id).toBe(data[1].id);
        expect(name).toBe(data[1].name);
        expect(typeValue).toBe(data[1].type);

        //reset id filter
        await idColumn.click();
        await page.waitForChanges();
        await filterButton[0].click();
        await page.waitForChanges();
        await filterButton[1].click();

        rows = await table.findAll(".uic-table__tr");
        expect(rows.length).toBe(2);

        //reset type filter
        await typeColumn.click();
        await page.waitForChanges();
        //click reset
        filterButton[2].click();
        await page.waitForChanges();
        //click confirm
        filterButton[3].click();
        await page.waitForChanges();

        rows = await table.findAll(".uic-table__tr");
        expect(rows.length).toBe(4);
    });
});
